// @flow

export const Empty = () => null;
